// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Field from "../layout-and-structure/Field.res.js";
import * as React from "react";
import * as ListBox from "./ListBox.res.js";
import * as Popover from "../overlays/Popover.res.js";
import * as ReactAria from "react-aria";
import * as InputSearch from "./InputSearch.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReactStately from "react-stately";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";

function InputSearchComboBoxField(props) {
  let onSelectionChange = props.onSelectionChange;
  let __itemTextValue = props.itemTextValue;
  let items = props.items;
  let __showResults = props.showResults;
  let __noResultLabel = props.noResultLabel;
  let __sectionTitle = props.sectionTitle;
  let errorMessage = props.errorMessage;
  let placeholder = props.placeholder;
  let __loading = props.loading;
  let __disabled = props.disabled;
  let __required = props.required;
  let label = props.label;
  let required = __required !== undefined ? __required : false;
  let disabled = __disabled !== undefined ? __disabled : false;
  let loading = __loading !== undefined ? __loading : false;
  let sectionTitle = __sectionTitle !== undefined ? __sectionTitle : I18n.t("Search results");
  let noResultLabel = __noResultLabel !== undefined ? __noResultLabel : I18n.t("No result found");
  let showResults = __showResults !== undefined ? __showResults : true;
  let itemTextValue = __itemTextValue !== undefined ? __itemTextValue : item => item.label;
  let match = React.useState(() => false);
  let setFocused = match[1];
  let focused = match[0];
  let triggerRef = React.useRef(null);
  let inputRef = React.useRef(null);
  let popoverRef = React.useRef(null);
  let listBoxRef = React.useRef(null);
  let children = React.useMemo(() => {
    if (showResults) {
      return [JsxRuntime.jsx(ReactStately.Section, {
          children: items.map(item => JsxRuntime.jsx(ReactStately.Item, {
            children: JsxRuntime.jsx("span", {
              children: item.label
            }),
            textValue: itemTextValue(item)
          }, item.key)),
          title: sectionTitle
        })];
    } else {
      return [];
    }
  }, [
    items,
    sectionTitle,
    showResults,
    itemTextValue
  ]);
  let onFocusChange = React.useCallback(focused => setFocused(param => focused), []);
  let onSelectionChange$1 = React.useCallback(key => Stdlib_Option.forEach(Stdlib_Option.flatMap((key == null) ? undefined : Primitive_option.some(key), key => items.find(item => item.key === key)), onSelectionChange), [items]);
  let props_aria$label = label;
  let props_inputValue = props.value;
  let props_onInputChange = props.onInputChange;
  let props_onSelectionChange = onSelectionChange$1;
  let props_onFocusChange = onFocusChange;
  let props$1 = {
    children: children,
    "aria-label": props_aria$label,
    isDisabled: disabled,
    placeholder: placeholder,
    allowsCustomValue: true,
    menuTrigger: "input",
    inputValue: props_inputValue,
    onInputChange: props_onInputChange,
    allowsEmptyCollection: true,
    onSelectionChange: props_onSelectionChange,
    onFocusChange: props_onFocusChange
  };
  let state = ReactStately.useComboBoxState(props$1);
  let newrecord = {...props$1};
  let match$1 = ReactAria.useComboBox((newrecord.popoverRef = Primitive_option.some(popoverRef), newrecord.listBoxRef = Primitive_option.some(listBoxRef), newrecord.inputRef = Primitive_option.some(inputRef), newrecord), state);
  React.useEffect(() => {
    if (focused && state.inputValue !== "") {
      setTimeout(() => state.close(), 5);
    }
  }, [state.selectedKey]);
  let onRequestClearSearch = React.useCallback(() => {
    if (state.inputValue !== "") {
      return state.setInputValue("");
    }
  }, [state.inputValue]);
  let errored = Stdlib_Option.isSome(errorMessage);
  let openedList = state.isOpen && state.inputValue !== "" && showResults && !loading;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(Field.make, {
        children: JsxRuntime.jsx(InputSearch.make, {
          loading: loading,
          onRequestClear: onRequestClearSearch,
          disabled: disabled,
          focused: focused,
          placeholder: placeholder,
          containerRef: triggerRef,
          inputRef: inputRef,
          ariaProps: match$1.inputProps
        }),
        label: label,
        errorMessage: errorMessage,
        required: required
      }),
      openedList ? JsxRuntime.jsx(Popover.make, {
          children: JsxRuntime.jsx(ListBox.make, {
            domRef: listBoxRef,
            state: state,
            props: match$1.listBoxProps,
            noResultLabel: noResultLabel
          }),
          popoverRef: popoverRef,
          triggerRef: triggerRef,
          state: {
            isOpen: state.isOpen,
            close: state.close,
            toggle: state.toggle
          },
          layout: "triggerStrictWidth",
          modal: false,
          offset: errored ? -16 : undefined
        }) : null
    ]
  });
}

let make = InputSearchComboBoxField;

export {
  make,
}
/* I18n Not a pure module */
